module.exports = __webpack_public_path__ + "img/green-2-diamond-striped.2b75c0de.svg";